export function verifyResultsLength(result, expectedResults, type) {
    result === expectedResults
        ? console.log(">>> SUCCESS: " + type + " match expected results - length")
        : console.error(">>> ERROR: " + type + " do not match expected results - length");
}
export function verifyResults(result, expectedResults, type) {
    result === expectedResults
        ? console.log(">>> SUCCESS: " + type + " match expected results")
        : console.error(">>> ERROR: " + type + " do not match expected results");
}
